import { render, staticRenderFns } from "./edit_file_name.vue?vue&type=template&id=04f8d271"
import script from "./edit_file_name.vue?vue&type=script&lang=js"
export * from "./edit_file_name.vue?vue&type=script&lang=js"
import style0 from "./edit_file_name.vue?vue&type=style&index=0&id=04f8d271&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports